<template>
	<div>
		<upload value="7205e0b575119e05649719c4119122f7" :params="uploadParams"></upload>
		<div></div>
		<upload value="7205e0b575119e05649719c4119122f7.png" :params="uploadParams"></upload>
		
	</div>
</template>

<script>
	import Upload from '@/components/Upload.vue'
	export default {
		name: 'FielDemo',
		components: {
			Upload
		},
		data() {
			return {
				fileId: '',
				uploadParams: {
					fileType: 'pdf'
				}
			}
		},
	}
</script>

<style>
</style>
